import * as React from "react";
import { DataGrid, useGridApiRef, gridFilteredSortedRowIdsSelector, gridVisibleColumnFieldsSelector } from "@mui/x-data-grid";
import Paper from "@mui/material/Paper";

const DataTable = React.forwardRef(({ columns = [], rows = [], height = 400 }, ref) => {
  const apiRef = useGridApiRef();

  React.useImperativeHandle(ref, () => ({
    getFilteredRows: () => {
      const filteredIds = gridFilteredSortedRowIdsSelector(apiRef);
      const visibleFields = gridVisibleColumnFieldsSelector(apiRef);

      return filteredIds.map((id) => {
        const row = apiRef.current.getRow(id);
        const filteredRow = {};
        visibleFields.forEach((field) => {
          filteredRow[field] = row[field];
        });
        return filteredRow;
      });
    }
  }));

  const paginationModel = { page: 0, pageSize: 10 };
  return (
    <Paper
      sx={{
        height: height,
        width: "100%",
        border: "none",
        borderRadius: "5px",
        overflow: "hidden",
      }}
    >
      <DataGrid
        apiRef={apiRef}
        rows={rows}
        columns={columns}
        pageSizeOptions={[10, 50, 100]}
        getRowId={(row) => row.id}
        initialState={{ pagination: { paginationModel } }}
        disableRowSelectionOnClick
        sx={{
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: "#7C2EA0",
            color: "#000",
            fontSize: "16px",
            fontWeight: "600",
            borderBottom: "2px solid #6a238a",
            boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            fontWeight: "bold",
          },
          "& .MuiDataGrid-row:nth-of-type(odd)": {
            backgroundColor: "#FFFFFF",
          },
          "& .MuiDataGrid-row:nth-of-type(even)": {
            backgroundColor: "#F8EAFF",
          },
          "& .MuiDataGrid-cell": {
            fontFamily: "'Inter', sans-serif",
            fontSize: "14px",
            paddingLeft:"20px"
          },
        }}
      />
    </Paper>
//   );
// };
  );
});

export default DataTable;
